// @ts-nocheck
import VoiceCreditsLogs from '@/features/voice-credits-logs/VoiceCreditsLogsPage';
import { API_TTS_CREDITS_LOGS } from '@/service/url';

export default function TtsCreditsLogsPage() {
  return (
    <VoiceCreditsLogs
      logsApi={API_TTS_CREDITS_LOGS}
      pageTitle="TTS Credits Logs"
      pageDescription="Additions and deductions of TTS credits across companies."
      exportFileName="tts-credits-logs"
      tableId="tts-credits-logs.page"
    />
  );
}
